import { MAX_AGE, MIN_AGE } from '@kamernet/constants/Search';
import { isArrayEmpty } from '@kamernet/utilities/Array/isArrayEmpty';

import { TenantsSearchSideFilters } from '../types';

interface Options {
  isMDUp: boolean;
}

const blankFilterCheckers: Record<
  keyof TenantsSearchSideFilters,
  (v: TenantsSearchSideFilters, o: Options) => boolean
> = {
  availabilityPeriods: v => {
    return isArrayEmpty(v.availabilityPeriods);
  },
  furnishings: v => {
    return isArrayEmpty(v.furnishings);
  },
  isPetsInsideAllowed: v => {
    return !v.isPetsInsideAllowed;
  },
  isSmokingInsideAllowed: v => {
    return !v.isSmokingInsideAllowed;
  },
  roommateGenders: v => {
    return isArrayEmpty(v.roommateGenders);
  },
  roommateNumberMax: v => {
    return !v.roommateNumberMax;
  },
  suitableForAgeRange: v => {
    return (
      v.suitableForAgeRange[0] === MIN_AGE &&
      v.suitableForAgeRange[1] === MAX_AGE
    );
  },
  suitableForGenders: v => {
    return isArrayEmpty(v.suitableForGenders);
  },
  suitableForNumberOfPersons: v => {
    return !v.suitableForNumberOfPersons;
  },
  suitableForWorkStatuses: v => {
    return isArrayEmpty(v.suitableForWorkStatuses);
  },
  maxRent: (v, o) => {
    return o.isMDUp ? true : !v.maxRent;
  },
  minSize: (v, o) => {
    return o.isMDUp ? true : !v.minSize;
  },
};

export function getTenantsSearchSideFiltersCount(
  sideFilters: TenantsSearchSideFilters,
  options: Options,
): number {
  let count = 0;

  for (const blankFilterChecker of Object.values(blankFilterCheckers)) {
    if (!blankFilterChecker(sideFilters, options)) {
      count += 1;
    }
  }

  return count;
}
